import { Button, Form, Input, Typography } from 'antd';
import { useState } from 'react';
import { changePassword } from '../services/auth';
import { clearSession } from '../stores/session';
import { ApiError } from '../lib/http';
import { AuthHeader } from './AuthHeader';

export function ChangePasswordPage() {
  const [old_password, setOld] = useState('');
  const [new_password, setNew] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const disabled = old_password.length < 6 || new_password.length < 6;

  return (
    <div className="auth-page">
      <AuthHeader />
      <div className="auth-main">
        <div className="auth-card" style={{ maxWidth: 440 }}>
          <h1>首次登录请修改密码</h1>
          <p className="auth-subtitle">修改成功后可重新登录；如非本人操作，请退出并联系实验员。</p>
          <Form layout="vertical">
            <Form.Item label="原密码">
              <Input.Password value={old_password} onChange={(e) => setOld(e.target.value)} />
            </Form.Item>
            <Form.Item label="新密码" extra="至少 6 位">
              <Input.Password value={new_password} onChange={(e) => setNew(e.target.value)} />
            </Form.Item>
            {error ? <Typography.Text type="danger">{error}</Typography.Text> : null}
            <Button
              type="primary"
              block
              className="touch"
              disabled={disabled}
              loading={loading}
              onClick={async () => {
                setLoading(true);
                setError('');
                try {
                  await changePassword(old_password, new_password);
                  clearSession();
                  window.location.replace('/login');
                } catch (e) {
                  setError(e instanceof ApiError ? e.message : '改密失败');
                } finally {
                  setLoading(false);
                }
              }}
            >
              保存并重新登录
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
}
